import { render, staticRenderFns } from "./AllMessages.vue?vue&type=template&id=24c2cb3d&scoped=true&"
import script from "./AllMessages.vue?vue&type=script&lang=js&"
export * from "./AllMessages.vue?vue&type=script&lang=js&"
import style0 from "./AllMessages.vue?vue&type=style&index=0&id=24c2cb3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c2cb3d",
  null
  
)

export default component.exports